var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fn-ui-button',_vm._b({ref:"button",attrs:{"tag":_vm.tag,"tooltip":_vm.$props.tooltip,"submitting":_vm.submitting,"icon":_vm.buttonIcon,"text":_vm.buttonText},on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},'fn-ui-button',{variant: _vm.$props.variant, size: _vm.$props.size},false))
}
var staticRenderFns = []

export { render, staticRenderFns }